import React from 'react'
import Devices from '../Devices/Devices'
import IssuesPage from '../Issue/IssuesPage'
import './styles/HomePage.scss'

type Props = {}

const HomePage = (props: Props) => {
  return (
    <div className="HomePage">
      <div className="HomePage-devices">
        <Devices basePath='/home'/>
      </div>
      <div className="HomePage-issues">
        <IssuesPage lite/>
      </div>
    </div>
  )
}

export default HomePage
